export default __webpack_public_path__ + "static/media/Pagos01.f51e5e78.svg";